import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CreditCardListComponent} from './credit-card-list/credit-card-list.component';
import {CardDetailComponent} from "./credit-card-list/card-detail/card-detail.component";
import {TermsConditionsComponent} from "./credit-card-list/terms-conditions/terms-conditions.component";
import {ErrorPageComponent} from "./error-page/error-page.component";

const routes: Routes = [
    {path: '', component: CreditCardListComponent},
    {path: 'error', component: ErrorPageComponent},
    {path: 'card-detail/:loanPurpose/:cardName', component: CardDetailComponent},
    {path: 'disclosures/:loanPurpose/:cardName', component: TermsConditionsComponent},
    {path: ':merchantId', pathMatch: 'full', component: CreditCardListComponent},
    {path: ':merchantId/:other', component: CreditCardListComponent},

    {path: '**', component: ErrorPageComponent},


];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
